import React from 'react'

export const ScoopNoRowsOverlay = () => {
    return <div>No data found</div>
}
